import { AlertCircle } from "lucide-react";
import type { ReactNode } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

type AlertVariant = "default" | "destructive" | "info";

interface AlertMessageProps {
  variant?: AlertVariant;
  title: string;
  description: ReactNode;
  icon?: ReactNode;
}

export function AlertMessage({
  variant = "default",
  title,
  description,
  icon = <AlertCircle className="h-4 w-4" />,
}: AlertMessageProps) {
  return (
    <Alert variant={variant}>
      {icon}
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
}
